export enum PackageFieldOptionType {
  Custom = "Custom",
  Barcode = "Barcode"
}